import React from 'react';
import styles from '../VideoAnalyzer.module.css';

const SubtitleOverlay = ({ transcriptSegments, partialTranscript }) => {
    const getCurrentSubtitleText = () => {
        if (!transcriptSegments?.length && !partialTranscript) return '';

        // Show last 2 completed segments plus partial
        const lastSegments = transcriptSegments.slice(-2).map(seg => seg.content).join(' ');
        return `${lastSegments} ${partialTranscript}`.trim();
    };

    return (
        <div className={styles.subtitleOverlay}>
            <div className={styles.subtitleText}>
                {getCurrentSubtitleText()}
            </div>
        </div>
    );
};

export default SubtitleOverlay;